import { createAction } from 'redux-act';
// save Mood Rating action
const saveMoodRatingRequest = createAction('SAVE_MOOD_RATING_REQUEST', data => data);
const saveMoodRatingSuccess = createAction('SAVE_MOOD_RATING_SUCCESS', data => data);
const saveMoodRatingError = createAction('SAVE_MOOD_RATING_ERROR');

// get MoodRating action
const getAllMoodRatingRequest = createAction('GET_ALL_MOOD_RATING_REQUEST', data => data);
const getAllMoodRatingSuccess = createAction('GET_ALL_MOOD_RATING_SUCCESS', data => data);
const getAllMoodRatingError = createAction('GET_ALL_MOOD_RATING_ERROR');

// find All Mood Rating action
const findDailyMoodRatingRequest = createAction('FIND_DAILY_MOOD_RATING_REQUEST', data => data);
const findDailyMoodRatingSuccess = createAction('FIND_DAILY_MOOD_RATING_SUCCESS', data => data);
const findDailyMoodRatingError = createAction('FIND_DAILY_MOOD_RATING_ERROR');

// find All Mood Rating action
const findAllMoodRatingRequest = createAction('FIND_ALL_MOOD_RATING_REQUEST', data => data);
const findAllMoodRatingSuccess = createAction('FIND_ALL_MOOD_RATING_SUCCESS', data => data);
const findAllMoodRatingError = createAction('FIND_ALL_MOOD_RATING_ERROR');

// Update MoodRating action
const ratingPercentRequest = createAction('RATING_PERCENT_REQUEST', data => data);
const ratingPercentSuccess = createAction('RATING_PERCENT_SUCCESS', data => data);
const ratingPercentError = createAction('RATING_PERCENT_ERROR');

// Delete MoodRating action
const dayWiseCoverageRequest = createAction('DAY_WISE_COVERAGE_REQUEST', data => data);
const dayWiseCoverageSuccess = createAction('DAY_WISE_COVERAGE_SUCCESS', data => data);
const dayWiseCoverageError = createAction('DAY_WISE_COVERAGE_ERROR');

//  key Employee Data action
const keyFunctionDataRequest = createAction('KEY_FUNCTION_DATA_REQUEST', data => data);
const keyFunctionDataSuccess = createAction('KEY_FUNCTION_DATA_SUCCESS', data => data);
const keyFunctionDataError = createAction('KEY_FUNCTION_DATA_ERROR');

//  key Employee Data action
const keyEmployeeDataRequest = createAction('KEY_EMPLOYEE_DATA_REQUEST', data => data);
const keyEmployeeDataSuccess = createAction('KEY_EMPLOYEE_DATA_SUCCESS', data => data);
const keyEmployeeDataError = createAction('KEY_EMPLOYEE_DATA_ERROR');

// clear existing MoodRating action
const handleClearMoodRatingStore = createAction('HANDLE_CLEAR_MOOD_RATING_STORE', data => data);
export default {
    saveMoodRatingRequest,
    saveMoodRatingSuccess,
    saveMoodRatingError,

    getAllMoodRatingRequest,
    getAllMoodRatingSuccess,
    getAllMoodRatingError,

    findDailyMoodRatingRequest,
    findDailyMoodRatingSuccess,
    findDailyMoodRatingError,


    findAllMoodRatingRequest,
    findAllMoodRatingSuccess,
    findAllMoodRatingError,

    ratingPercentRequest,
    ratingPercentSuccess,
    ratingPercentError,

    dayWiseCoverageRequest,
    dayWiseCoverageSuccess,
    dayWiseCoverageError,

    keyFunctionDataRequest,
    keyFunctionDataSuccess,
    keyFunctionDataError,

    keyEmployeeDataRequest,
    keyEmployeeDataSuccess,
    keyEmployeeDataError,


    handleClearMoodRatingStore,
    // toastMsgAction,

}